import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  RestaurantUnitConversionDTO,
  RestaurantUnitConversionForm,
  RestaurantUnitConversionPage,
} from '../../../types/restaurant/RestaurantUnitConversionTypes';

export const emptyUnitConversionForm: RestaurantUnitConversionForm = {
  fromUnitId: '',
  toUnitId: '',
  rawMaterialId: '',
  factor: 1,
};

interface State {
  list: RestaurantUnitConversionDTO[];
  page: RestaurantUnitConversionPage | null;
  form: RestaurantUnitConversionForm;
  loading: boolean;
  saving: boolean;
  modalOpen: boolean;
}

const initialState: State = {
  list: [],
  page: null,
  form: emptyUnitConversionForm,
  loading: false,
  saving: false,
  modalOpen: false,
};

const slice = createSlice({
  name: 'restaurantUnitConversion',
  initialState,
  reducers: {
    setUnitConversionPage(
      state,
      action: PayloadAction<RestaurantUnitConversionPage | null>
    ) {
      state.page = action.payload;
      state.list = action.payload?.content ?? [];
    },

    setUnitConversionLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setUnitConversionSaving(state, action: PayloadAction<boolean>) {
      state.saving = action.payload;
    },

    openUnitConversionCreate(state) {
      state.form = { ...emptyUnitConversionForm };
      state.modalOpen = true;
    },

    openUnitConversionEdit(
      state,
      action: PayloadAction<RestaurantUnitConversionDTO>
    ) {
      const item = action.payload;

      state.form = {
        id: item.id,
        fromUnitId: item.fromUnitId,
        toUnitId: item.toUnitId,
        rawMaterialId: item.rawMaterialId ?? '',
        factor: item.factor,
        active: item.active,
      };

      state.modalOpen = true;
    },

    closeUnitConversionModal(state) {
      state.form = { ...emptyUnitConversionForm };
      state.modalOpen = false;
    },

    updateUnitConversionField(
      state,
      action: PayloadAction<{
        field: keyof RestaurantUnitConversionForm;
        value: RestaurantUnitConversionForm[keyof RestaurantUnitConversionForm];
      }>
    ) {
      state.form = {
        ...state.form,
        [action.payload.field]: action.payload.value,
      };
    },
  },
});

export const {
  setUnitConversionPage,
  setUnitConversionLoading,
  setUnitConversionSaving,
  openUnitConversionCreate,
  openUnitConversionEdit,
  closeUnitConversionModal,
  updateUnitConversionField,
} = slice.actions;

export default slice.reducer;
